import * as React from 'react'

function SvgIconHeadphonesMic(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <g
        id="headphones-mic"
        aria-labelledby="t-headphones-mic d-headphones-mic"
      >
        <title id="t-headphones-mic">{'Headphones with microphone'}</title>
        <desc id="d-headphones-mic">
          {'Headphones with microphone front view'}
        </desc>
        <path d="M29 22.5c0 3.584-2.916 6.5-6.5 6.5H18v-1a1 1 0 00-1-1h-2a1 1 0 00-1 1v1a1 1 0 001 1h7.5c4.145 0 7.5-3.355 7.5-7.5V16c0-7.72-6.279-14-14-14C8.28 2 2 8.28 2 16v6.5a.5.5 0 001 0V22h2v2a2 2 0 004 0v-8a2 2 0 00-4 0v2H3v-2C3 8.832 8.832 3 16 3s13 5.832 13 13v2h-2v-2a2 2 0 00-4 0v8a2 2 0 004 0v-2h2v.5z" />
      </g>
    </svg>
  )
}

export default SvgIconHeadphonesMic
